export default "__VITE_ASSET__PolsBIaP__"